import { render, staticRenderFns } from "./groupTaskNeedsWork.vue?vue&type=template&id=607f6cac"
import script from "./groupTaskNeedsWork.vue?vue&type=script&lang=js"
export * from "./groupTaskNeedsWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports